module.exports = __webpack_public_path__ + "static/media/Shyvana_0.eecaff74.jpg";